<template>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      temporary
      fixed
      height=350px
      app
    >
      <v-list-item>
        <!-- <v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img>
        </v-list-item-avatar> -->
        <!-- <v-list-item id="logo">
          <v-img :src=logo />
        </v-list-item> -->

        <v-list-item-title>Navigation</v-list-item-title>

        <v-btn
          icon
          @click.stop="drawer = !drawer"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click="$router.push(item.path)"
          :disabled="item.requiresAuth && !isLogged"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider v-if="isLogged" style="margin:20px" />
      <v-row justify="center">
        <v-btn dark v-if="isLogged" outlined color='orange' @click="$emit('signout')">
          Sign Out 
        </v-btn>
      </v-row>
    </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    control: Boolean,
    list: Array,
    isLogged: Boolean
  },
  data () {
    return {
      mini: false,
    } 
  },
  metaInfo () {
    return {
      title: 'RSD'
    }
  },
  computed: {
    drawer: {
      get() {
        return this.control
      },
      set(val) {
        this.$emit('update',val)
      }
      
    },
    items : {
      get() {
        return this.list
      }
    }
  },
  watch: {
    'drawer': function (val) {
      console.log('Drawer is:', val)
    }
  }
}
</script>

<style>

#logo {
  max-width: 200px;
  width: 100%;
  padding: 2px;
}

</style>